var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3528 13.44L19.8118 29.272L11.5857 23.0218L11.5857 23.0217L11.5818 23.0189C10.9381 22.554 10.8217 21.6524 11.2976 20.9935C11.7621 20.3504 12.6624 20.2336 13.3212 20.7079L18.9574 24.9865L19.1268 25.1151L19.2447 24.9381L27.9695 11.851C28.4071 11.1946 29.3101 10.9877 29.9495 11.4495L29.9494 11.4496L29.9557 11.4537C30.6121 11.8913 30.819 12.7943 30.3572 13.4337L30.3571 13.4337L30.3528 13.44Z",
    fill: "#146C94",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckblue);
export default __webpack_public_path__ + "static/media/checkblue.46f9ea02497295e441e1f948630770a6.svg";
export { ForwardRef as ReactComponent };